export enum IconSize {
  Medium = 24,
  Small = 16,
}
